<div *ngIf="timeZone" class="timezone-info">{{timeZone}}</div>
